var _circle, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 36,
    height: 36,
    rx: 7,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5652,
    y: 34.5649,
    width: 18.8696,
    height: 18.8696,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5652 21C33.5652 20.4477 34.0129 20 34.5652 20H34.6521C35.2044 20 35.6521 20.4477 35.6521 21V25.2174H33.5652V21Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34.2173C67.5523 34.2173 68 34.665 68 35.2173L68 35.3042C68 35.8565 67.5523 36.3042 67 36.3042L62.7826 36.3042L62.7826 34.2173L67 34.2173Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8262 21C39.8262 20.4477 40.2739 20 40.8262 20H40.9131C41.4654 20 41.9131 20.4477 41.9131 21V25.2174H39.8262V21Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40.478C67.5523 40.478 68 40.9257 68 41.478L68 41.565C68 42.1173 67.5523 42.565 67 42.565L62.7826 42.565L62.7826 40.478L67 40.478Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0869 21C46.0869 20.4477 46.5346 20 47.0869 20H47.1739C47.7262 20 48.1739 20.4477 48.1739 21V25.2174H46.0869V21Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67 46.7393C67.5523 46.7393 68 47.187 68 47.7393L68 47.8262C68 48.3785 67.5523 48.8262 67 48.8262L62.7826 48.8262L62.7826 46.7393L67 46.7393Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3479 21C52.3479 20.4477 52.7956 20 53.3479 20H53.4349C53.9871 20 54.4349 20.4477 54.4349 21V25.2174H52.3479V21Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53C67.5523 53 68 53.4477 68 54L68 54.087C68 54.6392 67.5523 55.087 67 55.087L62.7826 55.087L62.7826 53L67 53Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5652 62.7827H35.6521V67.0001C35.6521 67.5524 35.2044 68.0001 34.6521 68.0001H34.5652C34.0129 68.0001 33.5652 67.5524 33.5652 67.0001V62.7827Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 34.2173L25.2173 36.3042L20.9999 36.3042C20.4476 36.3042 19.9999 35.8565 19.9999 35.3042L19.9999 35.2173C19.9999 34.665 20.4476 34.2173 20.9999 34.2173L25.2173 34.2173Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8262 62.7827H41.9131V67.0001C41.9131 67.5524 41.4654 68.0001 40.9131 68.0001H40.8262C40.2739 68.0001 39.8262 67.5524 39.8262 67.0001V62.7827Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 40.478L25.2173 42.565L20.9999 42.565C20.4476 42.565 19.9999 42.1173 19.9999 41.565L19.9999 41.478C19.9999 40.9257 20.4476 40.478 20.9999 40.478L25.2173 40.478Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0869 62.7827H48.1739V67.0001C48.1739 67.5524 47.7262 68.0001 47.1739 68.0001H47.0869C46.5346 68.0001 46.0869 67.5524 46.0869 67.0001V62.7827Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 46.7393L25.2173 48.8262L20.9999 48.8262C20.4476 48.8262 19.9999 48.3785 19.9999 47.8262L19.9999 47.7393C19.9999 47.187 20.4476 46.7393 20.9999 46.7393L25.2173 46.7393Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3479 62.7827H54.4349V67.0001C54.4349 67.5524 53.9871 68.0001 53.4349 68.0001H53.3479C52.7956 68.0001 52.3479 67.5524 52.3479 67.0001V62.7827Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 53L25.2173 55.087L20.9999 55.087C20.4476 55.087 19.9999 54.6392 19.9999 54.087L19.9999 54C19.9999 53.4477 20.4476 53 20.9999 53L25.2173 53Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChip);
export default __webpack_public_path__ + "static/media/ic-chip.b838cbca154e97b8422825f2fbdf812e.svg";
export { ForwardRef as ReactComponent };